/*
  Animated Placeholder for Search Bar
  Types out keywords after "Search for " prefix
*/
document.addEventListener('DOMContentLoaded', function () {
    initPlaceholderAnimation();
});

// Also re-init for dynamic content if needed (e.g. AJAX drawers)
document.addEventListener('shopify:section:load', function () {
    initPlaceholderAnimation();
});

function initPlaceholderAnimation() {
    const searchInputs = document.querySelectorAll('.search__input');
    if (searchInputs.length === 0) return;

    // Keywords to cycle through
    const phrases = ["T-Shirts", "Dresses", "Ethnic Wear", "Jackets & Zippers", "Frocks & Gowns", "Collections"];
    const prefix = "Search for ";

    searchInputs.forEach(input => {
        if (input.dataset.animationStarted) return;
        input.dataset.animationStarted = "true";

        let phraseIndex = 0;
        let charIndex = 0;
        let isDeleting = false;
        let typingSpeed = 100;

        function typeEffect() {
            // Stop animation if input is focused or has text
            if (document.activeElement === input || input.value.length > 0) {
                // Keep the prefix or full current word if focused
                // input.placeholder = prefix + "...";
                setTimeout(typeEffect, 1000);
                return;
            }

            const currentPhrase = phrases[phraseIndex];

            if (isDeleting) {
                charIndex--;
                typingSpeed = 50;
            } else {
                charIndex++;
                typingSpeed = 150;
            }

            const currentText = currentPhrase.substring(0, charIndex);
            // Using a underscore as a cursor
            const cursor = (charIndex < currentPhrase.length || isDeleting) ? "_" : "";

            input.placeholder = prefix + currentText + cursor;

            if (!isDeleting && charIndex === currentPhrase.length) {
                isDeleting = true;
                typingSpeed = 2000; // Pause at the end of word
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                phraseIndex = (phraseIndex + 1) % phrases.length;
                typingSpeed = 500;
            }

            setTimeout(typeEffect, typingSpeed);
        }

        setTimeout(typeEffect, 500);
    });
}
